
function Footer() {
   

    return (


        <footer className="bg-light py-5">
            <p className="text-center text-muted">© 2024 CodeWolf</p>
        </footer>



    )
}



export default Footer;